export const WEB3FORMS_KEY = 'ee98f396-073c-4428-a41b-2850a150c5aa';

const ENDPOINT = 'https://api.web3forms.com/submit';

export async function submitToWeb3Forms({ formName, subject, fields, replyTo }) {
  const payload = {
    access_key: WEB3FORMS_KEY,
    from_name: formName,
    subject: subject || `New ${formName} submission`,
    botcheck: '',
    ...(replyTo ? { replyto: replyTo } : {}),
    ...fields,
  };

  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Submission failed. Please try again.');
  }
  return data;
}
